import { Container, Paper, Typography, useMediaQuery } from "@mui/material";
import Footer from "../footer";

const FourOFour = () => {

    const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );

  return (
    <>
    <Container maxWidth={'xs'}>
      <Paper sx={{display: 'flex', px: isMobile ? '1rem': '3rem', borderRadius: '.625rem', flexDirection: 'column', mt: '2.5rem'}} elevation={0}>
        <Typography textAlign={'center'} sx={{fontWeight: 'bold', fontSize: '1.875rem', lineHeight: '2.25rem', pt: '1.5rem'}}>Permission Needed</Typography>
        <Typography sx={{fontSize: '.875rem', lineHeight: '1.375rem', py: '1.5rem'}} textAlign={'center'}>
          Your account has not been granted access to the NDC Admin app. Please
          contact a member of the NDC Commercial or Technical team to request
          access.
        </Typography>
      </Paper>
     
    </Container>
     <div style={{position: 'absolute', bottom: 0, width: '100%'}}>
     <Footer customStyle={{mx: '1rem'}} />
   </div>
   </>
  );
};

export default FourOFour;
